export const es_mx = {
  validation_error: 'Este campo es obligatorio.',
  all: 'Todo',
  filter_result_text: 'MOSTRANDO',
  filter_msg_title: 'No se han encontrado resultados.',
  filter_msg: 'No pudimos encontrar lo que buscas. Intenta buscar de nuevo.',
};
